import { render, staticRenderFns } from "./message-audio.vue?vue&type=template&id=d1608e6e&scoped=true&"
import script from "./message-audio.vue?vue&type=script&lang=js&"
export * from "./message-audio.vue?vue&type=script&lang=js&"
import style0 from "./message-audio.vue?vue&type=style&index=0&id=d1608e6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1608e6e",
  null
  
)

export default component.exports